import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ShipmentComponent from '../components/shipment.component';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectOrdersQueryItems } from '../../../../../redux/orders/selector';
import { selectAgentsListItems } from '../../../../../redux/agents/selector';
import { orders } from '../../../../../redux/orders/action';
import { agents } from '../../../../../redux/agents/action';
import PageLoader from '../../../../../components/PageLoader';
import { selectListItems } from '../../../../../redux/library/selector';


const ManagementOrder = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const libraryData = useSelector(selectListItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const orderQuery = useSelector(selectOrdersQueryItems)
  const transportAgentListItems = useSelector(selectAgentsListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const [
    selectShipping,
    setSelectShipping
  ] = useState<any>({})

  const OrderStatus = [
    {
      "Disabled": false,
      "Selected": false,
      "Text": "Pending",
      "Description": "Pending",
      "Value": 10
    },

    {
      "Disabled": false,
      "Selected": false,
      "Text": "Accepted",
      "Description": "Accepted",
      "Value": 22
    },
    {
      "Disabled": false,
      "Selected": false,
      "Text": "InProgress",
      "Description": "In-Progress",
      "Value": 24
    },
    {
      "Disabled": false,
      "Selected": false,
      "Text": "OutforDelivery",
      "Description": "OutforDelivery",
      "Value": 29
    },
    {
      "Disabled": false,
      "Selected": false,
      "Text": "Delivered",
      "Description": "Delivered",
      "Value": 30
    },
    {
      "Disabled": false,
      "Selected": false,
      "Text": "Completed",
      "Description": "Completed",
      "Value": 40
    },
    {
      "Disabled": false,
      "Selected": false,
      "Text": "RTOInitiated",
      "Description": "RTOInitiated",
      "Value": 42
    },
    {
      "Disabled": false,
      "Selected": false,
      "Text": "RTODelivered",
      "Description": "RTODelivered",
      "Value": 50
    },
    {
      "Disabled": false,
      "Selected": false,
      "Text": "Cancelled",
      "Description": "Cancelled",
      "Value": -10
    }
  ]

  const fetchorderById = () => {
    dispatch(orders.query({
      url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/sales/orders/fetch-detail`, entity: 'orders',
      jsonData:
      {
        "Context": {},
        "Records": [
          {
            "Id": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })
  }
  const handleInnerFormChange = (event: any, field: string) => {
    setSelectShipping({ ...selectShipping, [field]: event });
  }

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'VehicleBrand', headerName: 'Vehicle Brand' },
      { field: 'VehicleYear', headerName: 'Vehicle Year' }
    ]);
  }

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      dispatch(orders.update({
        url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/orders`, entity: 'orders', jsonData: {


          Records: [

            selectShipping

          ]

        }
      })).then(() => {
        back()
      })
    } else {
      dispatch(orders.create({
        url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/orders`, entity: 'orders', jsonData: {
          Records: [
            selectShipping

          ]

        }
      })).then(() => {
        back()
      })
    }

  }

  useEffect(
    () => {

      dispatch(agents.list({
        url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/rap-manager/agents/list`, entity: 'agents', jsonData: {

        }
      })).then(() => {
        if (parmas?.id > 0) {
          createColumnDefs()
          fetchorderById()
          setIsLoading(false)
        } else {
          setIsLoading(false)
        }
      })
    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectShipping(orderQuery?.result?.items)
      }
    },
    [isQuery]
  )


  const back = () => {
    navigate('/management/sales/orders')
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <ShipmentComponent
          rowData={selectShipping.MobilityOrderItems}
          columnDefs={columnDefs}
          orderStatus={libraryData?.result?.MobilityOrderStatus}
          selectShipping={selectShipping}
          handleInnerFormChange={handleInnerFormChange}
          transportAgents={transportAgentListItems.result.items}
          back={back}
          handleFormSubmit={handleFormSubmit}

        />
      }
    </>
  )

}

export default ManagementOrder;